// extracted by mini-css-extract-plugin
export default {"accountBalance":"style_accountBalance__yE9iz","label":"style_label__lR7Bz","balance":"style_balance__pKc2B","currency":"style_currency__62o+A"};